import { isPractitionerOnboardingProcess } from '../../util/practitionerOnboardingTransaction';
import {
  campaignBodyAsMessage,
  isPractitionerCampaignProcess,
  shouldShowCampaignConversation,
} from '../../util/practitionerCampaign';
import { isMarketingCampaignsEnabled } from '../../util/featureFlags';

/**
 * Pick the latest message from a denormalised transaction (messages included).
 * @param {Object} transaction
 * @returns {Object|null}
 */
export const latestMessageFromTransaction = transaction => {
  const messages = transaction?.messages;
  if (!Array.isArray(messages) || messages.length === 0) {
    return null;
  }
  return messages.reduce((latest, message) => {
    if (!latest) {
      return message;
    }
    const latestAt = latest?.attributes?.createdAt
      ? new Date(latest.attributes.createdAt).getTime()
      : 0;
    const messageAt = message?.attributes?.createdAt
      ? new Date(message.attributes.createdAt).getTime()
      : 0;
    return messageAt >= latestAt ? message : latest;
  }, null);
};

/**
 * Build conversation rows from denormalised order+sale transactions.
 * Excludes practitioner-onboarding TXs and TXs with no messages.
 *
 * @param {Array} transactions
 * @returns {Array<{ transaction: Object, latestMessage: Object }>}
 */
export const buildConversationsFromTransactions = (transactions, { currentUserId } = {}) => {
  return (transactions || [])
    .filter(tx => tx && !isPractitionerOnboardingProcess(tx?.attributes?.processName))
    .map(transaction => {
      if (
        isMarketingCampaignsEnabled() &&
        !shouldShowCampaignConversation(transaction, currentUserId)
      ) {
        return null;
      }
      const latestMessage =
        latestMessageFromTransaction(transaction) ||
        (isMarketingCampaignsEnabled() &&
        isPractitionerCampaignProcess(transaction?.attributes?.processName)
          ? campaignBodyAsMessage(transaction)
          : null);
      return latestMessage ? { transaction, latestMessage } : null;
    })
    .filter(Boolean);
};
